import { useMemo } from 'react';
import useGetQueueStatus from '@Hooks/queries/useGetQueueStatus';

const EXCLUDED_STATUS_IDS = [10, 11, 12];

const useGetStatusOptions = () => {
  const { data, isLoading } = useGetQueueStatus();

  const statusOptions = useMemo(() => {
    const list = data?.queueStatuses ?? [];
    return list
      .filter((s) => !EXCLUDED_STATUS_IDS.includes(s.id))
      .map((s) => ({ value: s.id, label: s.name }));
  }, [data]);

  return { statusOptions, isLoading };
};

export default useGetStatusOptions;
